import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';

import { ApplyRouteParams } from '../types/ApplyRouteParams';
import { isValidVin } from './isValidVin';

/**
 * Resolves the apply workflow step a hydrated application should resume at.
 */
export const toApplyRoute = ({
  applicationType,
  refinanceGoal,
  vin,
}: ApplyRouteParams): string => {
  if (applicationType === ApplicationType.PURCHASE) {
    // purchase type isn't collected via parameters, so it still needs to be selected
    return '/apply/purchase-type';
  }

  if (isValidVin(vin)) {
    // a valid VIN means we can skip straight to confirming vehicle details
    return '/apply/confirm-vehicle';
  }

  if (applicationType === ApplicationType.REFINANCE && !refinanceGoal) {
    return '/apply/refinance-goal';
  }

  if (applicationType === ApplicationType.LEASE_BUYOUT) {
    return '/apply/search-vehicle';
  }

  return '/apply/vehicle-selection';
};
